import * as Backbone from "backbone";

export class DashboardRange extends Backbone.Model {

    inRange(value: number) {
        var min = this.get('min') == null ? -Infinity : this.get('min')
        var max = this.get('max') == null ? Infinity : this.get('max')
        return value >= min && value < max
    }
    setMax(value) {
        this.set({ max: value })
    }
    setMin(value) {
        this.set({ min: value })
    }
    getIcon() {
        var icon = this.get('icon')
        if (icon) return icon.value;
    }
    setIcon(value) {
        this.set({ icon: value })
    }
    getValue(useMax: boolean) {
        if (useMax) return this.get('max');
        return this.get('min');
    }

}


// WEBPACK FOOTER //
// ./srv/public/js/models/DashboardRange.ts